module.exports = __webpack_public_path__ + "img/legal_entity.e370dd18.svg";